import { render, staticRenderFns } from "./insert.vue?vue&type=template&id=0e77980a"
import script from "./insert.vue?vue&type=script&lang=js"
export * from "./insert.vue?vue&type=script&lang=js"
import style0 from "./insert.vue?vue&type=style&index=0&id=0e77980a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports